module.exports = __webpack_public_path__ + "static/media/unevenhip_severe_right.d1247965.png";